import { initializeApp } from "firebase/app";
import { getFirestore, connectFirestoreEmulator } from "firebase/firestore";
import { getAuth, connectAuthEmulator } from "firebase/auth";
import { getStorage, connectStorageEmulator } from "firebase/storage";
import { getAnalytics } from "firebase/analytics";

const firebaseConfig = {
  apiKey: "AIzaSyBxJz09Ue8BrZ1cK3H9XMosG3ccOV5IvZc",
  authDomain: "kid-svibe.firebaseapp.com",
  projectId: "kid-svibe",
  storageBucket: "kid-svibe.firebasestorage.app",
  messagingSenderId: "200331664473",
  appId: "1:200331664473:web:ab5a9876c74bb49ef3e548"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize services
export const db = getFirestore(app);
export const auth = getAuth(app);

// Initialize Storage with explicit configuration
export const storage = getStorage(app);

// Initialize Analytics
export const analytics = getAnalytics(app);

// Force storage to use production endpoints
if (typeof window !== 'undefined') {
  console.log('✅ Firebase Storage initialized');
  console.log('📂 Storage bucket:', app.options.storageBucket);
  console.log('🌐 Storage host:', storage._host || 'default');
}

export default app;
